import { Address, erc4626Abi } from "viem"
import { useReadContract } from "wagmi"

import { query } from "#/shared/constants"

export default function useVaultUnderlyingToken(vault: Address) {
  return useReadContract({
    address: vault,
    abi: erc4626Abi,
    functionName: "asset",
    query: { ...query.FETCH_ONLY_ONCE_OPTIONS },
  })
}
